

















import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryShopWealthRecordList,QueryAllShopNameList,ExportShopWealthRecordList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { ShopWealthRecordTypeFormat,ShopWealthWayTypeFormat,PriceFormat } from '@/utils/tyepconvert'
import constan from '@/utils/constant'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private activeMenu = "ALL"
  private selectData: Array<any> = []

  private shopIdOption: Array<any> = []


  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '资金类型', param: 'type', type: 'select',selectData: constan.ShopWealthRecordType },
    { title: '变更途径', param: 'wayType', type: 'select',selectData: constan.ShopWealthWayType },
    { title: '关联号', param: 'recordNo' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '批量导出', type: 'primary', click: this.exportHandle},
  ]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '选择',  type: 'selection' },
    { title: '编号', param: 'id' ,width: 80},
    { title: '店铺ID', param: 'shopId',width: 120 },
    { title: '店铺名称', param: 'shopName',width: 200,overflow: true },
    { title: '资金类型', param: 'type' , formatter: ShopWealthRecordTypeFormat},
    { title: '变动金额', param: 'qty', formatter: PriceFormat },
    { title: '变更途径', param: 'wayType' , formatter: ShopWealthWayTypeFormat},
    { title: '关联号', param: 'recordNo' },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
  ]

  public async created() {
    this.loadShop()
    this.loadData()
  }

  private selectChange(selection: any) {
    this.selectData = selection
  }

  //。选择菜单
  private activeMenuSelect(e:string){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    this.search()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })


  }

  private exportHandle(){
    // 导出
    // if(this.selectData.length <= 0){
    //   return
    // }

    const loading = this.$loading({
          lock: true,
          text: '正在导出数据',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

      const param = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      const ids = this.selectData.map(e=>e.id)
      param.ids = ids

      ExportShopWealthRecordList(param,"导出店铺流水.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryShopWealthRecordList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam(){
    const param: any= { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)

    if(this.activeMenu == 't1'){
      param.type = 1
    } else if(this.activeMenu == 't2'){
      param.type = 2
    } else if(this.activeMenu == 't3'){
      param.type = 3
    } else if(this.activeMenu == 't4'){
      param.type = 4
    } else if(this.activeMenu == 't5'){
      param.type = 5
    }
    if (param.createTimeDaterange) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
